import React, { useEffect, useState } from "react";
import { fetchData, postData, deleteData, activateData } from '../../../apiService';
import { useParams, useHistory } from 'react-router-dom';
import {
    FaCalendarCheck,
    FaCalendarAlt,
    FaThumbsUp,
    FaThumbsDown,
    FaUserEdit,
    FaUserPlus,
    FaBalanceScale,
    FaArrowRight,
} from "react-icons/fa";
import phonepe from '../Img/phonepe.png';

const UserDashboard = () => {
    const userId = 1;

    const [user, setUser] = useState(null);
    const [subscription, setSubscription] = useState(null);
    const [payments, setPayments] = useState([]);

    // User Details
    const fetchtableData = async () => {
        const companyId = 1;
        try {
            const response = await fetchData('UserApi', `/LoggedUserData/${userId}`);
            if (response.responseCode === '1111') {
                console.log(response.response_data);
                setUser(response.response_data);
            }
        } catch (error) {
            console.error('Error fetching Subscription Plans Details:', error);
        }
    };

    // Current Subscription Plan
    const fetchtableSubscriptionData = async () => {
        const companyId = 1;
        try {
            const response = await fetchData('UserApi', `/UserSubscriptionPlan/${userId}`);
            if (response.responseCode === '1111') {
                console.log(response.response_data);
                setSubscription(response.response_data);
            }
        } catch (error) {
            console.error('Error fetching Subscription Plans Details:', error);
        }
    };

    useEffect(() => {
        fetchtableData();
        fetchtableSubscriptionData();
    }, []);

    const formatDate = (date) => new Date(date).toDateString();

    // Add sub-User
    const [showAddUserModal, setShowAddUserModal] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [successMessage, setSuccessMessage] = useState("");
    const history = useHistory();

    const [formData, setFormData] = useState({
        Name: '',
        Gender: true,
        DateofBirth: '',
        TimeoBirth: "00:00",
        PlaceofBirth: '',
        unknownTime: false,
        ContactNumber: '',
        Email: '',
    });

    const handleChange = (event) => {
        const { name, value, type, checked } = event.target;

        setFormData((prevData) => ({
            ...prevData,
            [name]:
                name === "Gender"
                    ? value === "1" // convert string to boolean
                    : type === "checkbox"
                        ? checked
                        : value,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!formData.Name) {
            setErrorMessage('Name is required !');
            setIsLoading(false);
            return;
        }
        if (!formData.DateofBirth) {
            setErrorMessage('Date of Birth is required !');
            setIsLoading(false);
            return;
        }
        if (!formData.PlaceofBirth) {
            setErrorMessage('place is required !');
            setIsLoading(false);
            return;
        }

        const CreateData = {
            ...formData,
            CreatedBy: 1,
            CompanyId: 1,
            CreatedDate: new Date(),
        };

        try {
            const response = await postData('UserApi', CreateData);
            console.log('User Profile Created successfully:', response.data);
            // history.push(`/UserPlan/${response.recordId}`); // Redirect to UserPlan with the new user's ID
            history.push(`/UserPlan/${response.recordId}`);
        } catch (error) {
            console.error('Error User Profile record:', error);
            setErrorMessage('Failed to Create User Profile. Please try again.');
        } finally {
            setIsLoading(false);
        }
    };

    // Plan - Renewal / activating new plan
    const [showPlanModal, setShowPlanModal] = useState(false);
    const [selectedPlan, setSelectedPlan] = useState(null);

    const [showRenewalPlanModal, setShowRenewalPlanModal] = useState(false);

    // Renewal plan 
    const [renewalplans, setRenewalPlans] = useState([]);
    const fetchtableRenewalData = async () => {
        try {
            const response = await fetchData('SubscriptionPlansApi', `/selectedplan/${subscription.Id}`);
            if (response.responseCode === '1111') {
                setRenewalPlans(response.response_data);
            }
        } catch (error) {
            console.error('Error fetching Subscription Plans Details:', error);
        }
    };

    // New Plan
    const [plans, setPlans] = useState([]);
    const fetchtablePlanData = async () => {
        const companyId = 1;
        try {
            const response = await fetchData('SubscriptionPlansApi', `/${companyId}`);
            if (response.responseCode === '1111') {
                console.log(response.response_data);
                setPlans(response.response_data);
            }
        } catch (error) {
            console.error('Error fetching Subscription Plans Details:', error);
        }
    };

    useEffect(() => {
        fetchtablePlanData();
        fetchtableRenewalData();
    }, []);
                                        
    const handleArrowClick = (e, pid) => {
        e.stopPropagation();
        history.push(`/payment/${userId}/${pid}`); 
    };

    const handlePayment = (method) => {
        alert(`Payment via ${method} successful for ${renewalplans.Name} plan!`);
        history.push("/");
    };

    return (
        <div className="p-4 bg-[#121212] min-h-screen font-sans">
            <h5
                className="font-bold text-center text-white mb-8 text-xl"
                style={{ textTransform: "uppercase" }}
            >
                User Profile
            </h5>

            <div
                className="grid grid-cols-1 lg:grid-cols-3 gap-4"
                style={{ borderRadius: "25px" }}
            >
                {/* Left Section - User + Subscription stacked on smaller screens */}
                <div className="lg:col-span-2 grid grid-cols-1 md:grid-cols-2 gap-4">
                    {/* User Info Card */}
                    <div className="shadow-xl rounded-2xl p-6 border border-gray-800 bg-[#1e1e1e]" style={{ background: '#1e1e1e', borderRadius: '20px' }}>
                        <h6 className="font-semibold text-white mb-4">
                            <span className="inline-block bg-white text-black px-2 py-1 rounded-full mr-2">👤</span>
                            User Info
                        </h6>
                        {user ? (
                            <div className="space-y-2 text-sm text-white">
                                <p>
                                    <span className="font-semibold">Name:</span> {user.Name}
                                </p>
                                <p>
                                    <span className="font-semibold">Email:</span> {user.Email}
                                </p>
                                <p>
                                    <span className="font-semibold">Joined:</span>{" "}
                                    {formatDate(user.CreatedDate)}
                                </p>

                                <button
                                    onClick={() => setShowAddUserModal(true)}
                                    style={{ borderRadius: '20px' }}
                                    className="bg-white text-black px-4 py-1 rounded hover:bg-green-500 transition"
                                >
                                    Add sub User
                                </button>
                            </div>
                        ) : (
                            <p className="text-gray-400">Loading user details...</p>
                        )}
                    </div>

                    {/* Subscription Info Card */}
                    <div className="shadow-xl rounded-2xl p-6 border border-gray-800 bg-[#1e1e1e]" style={{ background: '#1e1e1e', borderRadius: '20px' }}>
                        <h6 className="font-semibold text-white mb-4">📦 Subscription Plan</h6>
                        {subscription ? (
                            <div className="space-y-2 text-sm text-white">
                                <p>
                                    <span className="font-semibold">Plan:</span>{" "}
                                    {subscription.PlanDuration}
                                </p>
                                <p>
                                    <span className="font-semibold">Start Date:</span>{" "}
                                    {formatDate(subscription.PlanStartDate)}
                                </p>
                                <p>
                                    <span className="font-semibold">End Date:</span>{" "}
                                    {formatDate(subscription.PlanEndDate)}
                                </p>
                                {new Date(subscription.PlanEndDate) - new Date() <
                                    7 * 24 * 60 * 60 * 1000 && (
                                        <div className="mt-2 p-2 bg-yellow-100 text-yellow-800 rounded">
                                            ⚠️ Your subscription is expiring soon!
                                        </div>
                                    )}
                                <div className="flex justify-center space-x-3 mt-4">
                                    <button
                                        // onClick={handleRenewal}
                                        onClick={() => setShowRenewalPlanModal(true)}
                                        style={{ borderRadius: '20px', color: 'red' }}
                                        className="bg-white px-4 py-1 rounded hover:bg-green-500 transition"
                                    >
                                        Renewal on same plan
                                    </button>
                                    <button style={{ marginLeft: '5px', color: 'black' }}
                                        onClick={() => setShowPlanModal(true)}
                                        className="bg-white px-4 py-1 rounded hover:bg-blue-500 transition"
                                    >
                                        Details
                                    </button>
                                </div>

                            </div>
                        ) : (
                            <p className="text-gray-400">Loading subscription details...</p>
                        )}
                    </div>
                </div>

                {/* Right Section - Payment History */}
                <div className="shadow-xl rounded-2xl p-6 border border-gray-800 bg-[#1e1e1e] h-fit" style={{ background: '#1e1e1e', borderRadius: '20px' }}>
                    <h6 className="font-semibold text-white mb-4">
                        💳 Payment History
                    </h6>
                    {payments.length ? (
                        <div className="overflow-x-auto">
                            <table className="min-w-full text-sm text-left text-gray-300">
                                <thead className="bg-gray-800 text-xs uppercase text-gray-400 border-b border-gray-600">
                                    <tr>
                                        <th className="px-4 py-2">Date</th>
                                        <th className="px-4 py-2">Method</th>
                                        <th className="px-4 py-2">Amount</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {payments.map((payment, index) => (
                                        <tr key={index} className="border-b border-gray-700 hover:bg-gray-800">
                                            <td className="px-4 py-2">{formatDate(payment.date)}</td>
                                            <td className="px-4 py-2">{payment.method}</td>
                                            <td className="px-4 py-2">₹{payment.amount}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    ) : (
                        <p className="text-gray-400">No payment records found.</p>
                    )}
                </div>

                {showAddUserModal && (
                    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                        <div className="p-6 rounded-xl w-96 shadow-lg border border-gray-800 text-white relative" style={{ background: '#1e1e1e', borderRadius: '20px' }}>
                            <h5 className="font-bold mb-4 text-center text-green-800" style={{ fontFamily: 'monospace', textTransform: 'uppercase', color: 'whitesmoke', marginTop: '-10px' }}>New User</h5>
                            <form onSubmit={handleSubmit} className="space-y-4">

                                {/* Name */}
                                <div className='m-2'>
                                    <label className="block text-sm font-medium text-gray-700" style={{ color: 'whitesmoke', textTransform: 'uppercase', marginTop: '-30px', fontFamily: 'monospace' }}>Name</label>
                                    <input
                                        type="text"
                                        name="Name"
                                        required
                                        className="w-full px-4 py-2 border rounded-md h-8"
                                        value={formData.Name}
                                        onChange={handleChange}
                                        placeholder='Enter your name'
                                        style={{
                                            width: "100%",
                                            padding: "10px 10px 10px 40px",
                                            borderRadius: "8px",
                                            border: "1px solid #4c6793",
                                            background: "#2E2E2E",
                                            color: "#fff",
                                            outline: "none",
                                            transition: "border 0.3s ease",
                                        }}
                                    />
                                </div>

                                {/* Gender */}

                                <div className='m-2'>
                                    <label className="block text-sm font-medium text-gray-700" style={{ color: 'whitesmoke', textTransform: 'uppercase', marginTop: '10px', fontFamily: 'monospace' }}>Gender</label>
                                    <div className="flex space-x-4 mt-1">
                                        <label className="inline-flex items-center" style={{ color: 'whitesmoke', marginTop: '5px' }}>
                                            <input
                                                type="radio"
                                                name="Gender"
                                                value="1"
                                                checked={formData.Gender === true}
                                                onChange={handleChange}
                                            />
                                            <span className="ml-2">Male</span>
                                        </label>
                                        <label className="inline-flex items-center" style={{ color: 'whitesmoke', marginLeft: '7px', marginTop: '5px' }}>
                                            <input
                                                type="radio"
                                                name="Gender"
                                                value="0"
                                                checked={formData.Gender === false}
                                                onChange={handleChange}
                                            />
                                            <span className="ml-2">Female</span>
                                        </label>
                                    </div>
                                </div>

                                <div className='m-2'>
                                    <label className="block text-sm font-medium text-gray-700" style={{ color: 'whitesmoke', textTransform: 'uppercase', marginTop: '10px', fontFamily: 'monospace' }}>Contact Number</label>
                                    <input
                                        type="text"
                                        name="ContactNumber"
                                        required
                                        className="w-full px-4 py-2 border rounded-md h-8"
                                        value={formData.ContactNumber}
                                        onChange={handleChange}
                                        placeholder='Enter your contact number'
                                        style={{
                                            width: "100%",
                                            padding: "10px 10px 10px 40px",
                                            borderRadius: "8px",
                                            border: "1px solid #4c6793",
                                            background: "#2E2E2E",
                                            color: "#fff",
                                            outline: "none",
                                            transition: "border 0.3s ease",
                                        }}
                                    />
                                </div>
                                <div className='m-2'>
                                    <label className="block text-sm font-medium text-gray-700" style={{ color: 'whitesmoke', textTransform: 'uppercase', marginTop: '10px', fontFamily: 'monospace' }}>Email</label>
                                    <input
                                        type="text"
                                        name="Email"
                                        required
                                        className="w-full px-4 py-2 border rounded-md h-8"
                                        value={formData.Email}
                                        onChange={handleChange}
                                        placeholder='Enter your email'
                                        style={{
                                            width: "100%",
                                            padding: "10px 10px 10px 40px",
                                            borderRadius: "8px",
                                            border: "1px solid #4c6793",
                                            background: "#2E2E2E",
                                            color: "#fff",
                                            outline: "none",
                                            transition: "border 0.3s ease",
                                        }}
                                    />
                                </div>
                                {/* DOB */}
                                <div className='m-2'>
                                    <label className="block text-sm font-medium text-gray-700" style={{ color: 'whitesmoke', textTransform: 'uppercase', marginTop: '10px', fontFamily: 'monospace' }}>Date of Birth</label>
                                    <input
                                        type="date"
                                        name="DateofBirth"
                                        required
                                        className="w-full px-4 py-2 border rounded-md h-8"
                                        value={formData.DateofBirth}
                                        onChange={handleChange}
                                        style={{
                                            width: "100%",
                                            padding: "10px 10px 10px 40px",
                                            borderRadius: "8px",
                                            border: "1px solid #4c6793",
                                            background: "#2E2E2E",
                                            color: "#fff",
                                            outline: "none",
                                            transition: "border 0.3s ease",
                                        }}
                                    />
                                </div>
                                {/* Checkbox for Unknown TOB */}
                                <div className="flex items-center space-x-2">
                                    <input
                                        type="checkbox"
                                        name="unknownTime"
                                        checked={formData.unknownTime}
                                        onChange={handleChange}
                                        style={{ marginTop: '10px' }}
                                    />
                                    <label className="text-sm text-gray-700" style={{ color: 'whitesmoke', textTransform: 'uppercase', marginTop: '10px', marginLeft: '5px', fontFamily: 'monospace' }}> I don’t know my time of birth</label>
                                </div>

                                {/* TOB */}
                                {!formData.unknownTime && (
                                    <div className='m-2'>
                                        <label className="block text-sm font-medium text-gray-700" style={{ color: 'whitesmoke', textTransform: 'uppercase', marginTop: '10px', fontFamily: 'monospace' }}>Time of Birth</label>
                                        <input
                                            type="time"
                                            name="TimeoBirth"
                                            className="w-full px-4 py-2 border rounded-md h-8"
                                            //value={formData.TimeoBirth}
                                            value={formData.TimeoBirth || "00:00"}  // fallback to 00:00
                                            onChange={handleChange}
                                            required
                                            style={{
                                                width: "100%",
                                                padding: "10px 10px 10px 40px",
                                                borderRadius: "8px",
                                                border: "1px solid #4c6793",
                                                background: "#2E2E2E",
                                                color: "#fff",
                                                outline: "none",
                                                transition: "border 0.3s ease",
                                            }}
                                        />
                                    </div>
                                )}
                                {/* Place of Birth */}
                                <div className='m-2'>
                                    <label className="block text-sm font-medium text-gray-700" style={{ color: 'whitesmoke', textTransform: 'uppercase', marginTop: '10px', fontFamily: 'monospace' }}>Place of Birth</label>
                                    <input
                                        type="text"
                                        name="PlaceofBirth"
                                        required
                                        className="w-full px-4 py-2 border rounded-md h-8"
                                        value={formData.PlaceofBirth}
                                        onChange={handleChange}
                                        placeholder='Enter your place of birth'
                                        style={{
                                            width: "100%",
                                            padding: "10px 10px 10px 40px",
                                            borderRadius: "8px",
                                            border: "1px solid #4c6793",
                                            background: "#2E2E2E",
                                            color: "#fff",
                                            outline: "none",
                                            transition: "border 0.3s ease",
                                        }}
                                    />
                                </div>
                                {/* Submit Button */}

                                <div className="flex justify-center space-x-2">
                                    <button onClick={() => setShowAddUserModal(false)} className="px-4 py-1 rounded bg-red-600 hover:bg-red-700">Cancel</button>
                                    <button className="px-4 py-1 rounded bg-green-600 hover:bg-green-500" style={{ marginLeft: '5px' }}>Save</button>
                                </div>

                            </form>
                        </div>
                    </div>
                )}

                {/* Plan Selection Modal */}
                {showPlanModal && (
                    <div
                        className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center"
                        onClick={() => setShowPlanModal(false)} // 👈 close on overlay click
                    >
                        <div
                            className="p-6 rounded-xl w-96 shadow-lg border border-gray-800 text-white relative"
                            style={{ background: '#1e1e1e', borderRadius: '20px' }}
                            onClick={(e) => e.stopPropagation()} // 👈 prevent closing when clicking inside modal
                        >
                            <div className="flex items-center justify-between mb-4">
                                <h5
                                    className="font-bold text-green-800 text-center flex-1"
                                    style={{
                                        fontFamily: 'monospace',
                                        textTransform: 'uppercase',
                                        color: 'whitesmoke',
                                    }}
                                >
                                    Subscription Plan
                                </h5>
                            </div>

                            <div style={{ padding: '20px', marginTop: '-20px' }}>
                                <div
                                    style={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        gap: '20px',
                                        maxWidth: '600px',
                                        margin: '0 auto',
                                    }}
                                >
                                    {plans.map((item, index) => (
                                        <div
                                            key={index}
                                            onClick={() => setSelectedPlan(item)}
                                            style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'space-between',
                                                background: '#2E2E2E',
                                                padding: '20px',
                                                borderRadius: '16px',
                                                color: '#fff',
                                                boxShadow: '4px 4px 10px rgba(255, 255, 255, 0.1)',
                                                cursor: 'pointer',
                                                transition: 'transform 0.2s',
                                            }}
                                            onMouseEnter={(e) => (e.currentTarget.style.transform = 'scale(1.02)')}
                                            onMouseLeave={(e) => (e.currentTarget.style.transform = 'scale(1)')}
                                        >
                                            <div>
                                                <div
                                                    style={{
                                                        fontSize: '18px',
                                                        fontWeight: 'bold',
                                                        color: '#80ff80',
                                                    }}
                                                >
                                                    {item.name}
                                                </div>
                                                <div style={{ fontSize: '14px', margin: '4px 0', color: '#ccc' }}>
                                                    Duration: {item.planDuration} days
                                                </div>
                                                <div style={{ fontSize: '14px', color: '#bbb' }}>{item.description}</div>
                                            </div>
                                            <div style={{ fontSize: '20px', color: '#FFD700', fontWeight: 'bold' }}>
                                                ₹{item.amount}
                                            </div>
                                            <FaArrowRight
                                                size={19}
                                                style={{ color: '#fff', cursor: 'pointer', marginLeft: '5px' }}
                                                onClick={(e) => handleArrowClick(e, item.id)}
                                            />
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {showRenewalPlanModal && (
                    <div
                        className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center"
                        onClick={() => setShowRenewalPlanModal(false)} // 👈 close on overlay click
                    >
                        <div
                            className="p-6 rounded-xl w-96 shadow-lg border border-gray-800 text-white relative"
                            style={{ background: '#1e1e1e', borderRadius: '20px' }}
                            onClick={(e) => e.stopPropagation()} // 👈 prevent closing when clicking inside modal
                        >



                            {/* Lock Icon & Step */}
                            <div style={{ textAlign: "center", marginBottom: "20px" }}>
                                <h6 style={{ color: "whitesmoke", textTransform: 'uppercase', fontWeight: 'bold' }}>Payment Details</h6>
                            </div>

                            {/* Plan Details */}
                            {/* <div style={{
                                backgroundColor: "#2E2E2E",
                                borderRadius: "8px",
                                marginBottom: "20px",
                                textAlign: "left",
                                color: "whitesmoke",
                            }}>
                                <h6 style={{ marginBottom: "10px", fontFamily: 'monospace', marginLeft: '20px' }}>{renewalplans.Name} Plan</h6>
                                <p><strong style={{ marginTop: '-5px', fontSize: '14px', fontFamily: 'monospace', marginLeft: '20px' }}>Duration:</strong> {renewalplans.PlanDuration} days</p>
                                <p style={{ marginTop: '-5px', fontFamily: 'monospace' }}><strong style={{ fontSize: '14px', fontFamily: 'monospace', marginLeft: '20px' }}>Description:</strong> {renewalplans.Description}</p>
                                <p style={{ marginTop: '-5px', fontSize: "18px", color: "#9ee4d2ff", fontFamily: 'monospace' }}>
                                    <strong style={{ marginTop: '-5px', fontFamily: 'monospace', marginLeft: '20px' }}>Amount: ₹{renewalplans.Amount}</strong>
                                </p>
                            </div> */}
                            {subscription ? (
                                <div className="space-y-2 text-sm text-white">
                                    <p>
                                        <span className="font-semibold">Plan:</span>{" "}
                                        {subscription.PlanDuration}
                                    </p>
                                    <p>
                                        <span className="font-semibold">Start Date:</span>{" "}
                                        {formatDate(subscription.PlanStartDate)}
                                    </p>
                                    <p>
                                        <span className="font-semibold">End Date:</span>{" "}
                                        {formatDate(subscription.PlanEndDate)}
                                    </p>
                                    {new Date(subscription.PlanEndDate) - new Date() <
                                        7 * 24 * 60 * 60 * 1000 && (
                                            <div className="mt-2 p-2 bg-yellow-100 text-yellow-800 rounded">
                                                ⚠️ Your subscription is expiring soon!
                                            </div>
                                        )}

                                </div>
                            ) : (
                                <p className="text-gray-400">Loading subscription details...</p>
                            )}

                            {/* Payment Option 1 */}
                            <div style={{ marginBottom: "15px", border: "1px solid #ddd", borderRadius: "8px", cursor: "pointer", backgroundColor: "#2E2E2E", color: "#fff" }}
                                onClick={() => handlePayment("Credit/Debit Card")}>
                                <div style={{ padding: "15px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                    <span style={{ fontFamily: 'monospace', fontWeight: 'bold', color: 'whitesmoke' }}>Credit or Debit Card</span>
                                    <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                                        <img src="https://img.icons8.com/color/32/visa.png" alt="visa" />
                                        <img src="https://img.icons8.com/color/32/mastercard.png" alt="mastercard" />
                                    </div>
                                </div>
                            </div>

                            {/* Payment Option 2 */}
                            <div style={{ border: "1px solid #ddd", borderRadius: "8px", cursor: "pointer", backgroundColor: "#2E2E2E", color: "#fff" }}
                                onClick={() => handlePayment("UPI AutoPay")}>
                                <div style={{ padding: "15px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                    <span style={{ fontFamily: 'monospace', fontWeight: 'bold', color: 'whitesmoke' }}>UPI AutoPay</span>
                                    <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                                        <img src={phonepe} style={{ width: "29px", height: "29px", borderRadius: '25px' }} />
                                        <img src="https://img.icons8.com/color/32/google-pay.png" alt="gpay" />
                                        <img style={{ background: 'white', borderRadius: '10px', width: '30%' }} src="https://img.icons8.com/color/32/paytm.png" alt="paytm" />
                                    </div>
                                </div>
                            </div>


                            <div style={{ marginTop: "30px", textAlign: "center" }}>
                                <p style={{ color: "#888", fontSize: "12px" }}>End-to-end encrypted 🔒</p>
                            </div>

                        </div>
                    </div>
                )}

            </div>
        </div>

    );

};

export default UserDashboard;
